import React from 'react';
import { FadeIn } from './ui';
export const HowItWorks = () => {
  const steps = ['Open the PDF on your phone (in night mode) the next time you wake up in a loop.', 'Follow the 2-minute physical tension release to stabilize your heart rate.', 'Begin the "Alpha-Word" shuffling script to override your internal monologue and drift off.'];
  return <section className="py-16 px-6" data-id="element-77">
      <div className="max-w-2xl mx-auto" data-id="element-78">
        <FadeIn data-id="element-79">
          <h2 className="text-3xl text-center mb-12" data-id="element-80">How it works tonight</h2>
        </FadeIn>

        <div className="space-y-8 relative before:absolute before:inset-0 before:ml-[1.125rem] before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-white/10 before:to-transparent" data-id="element-81">
          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-82">
              <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-83">
                <div className="flex items-center justify-center w-10 h-10 rounded-full border border-white/10 bg-midnight text-amber font-serif text-lg shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow-[0_0_0_4px_#0a1020] z-10" data-id="element-84">
                  {index + 1}
                </div>
                <div className="w-[calc(100%-3rem)] md:w-[calc(50%-2.5rem)] p-6 rounded-xl bg-surface/30 border border-white/5" data-id="element-85">
                  <p className="text-parchment-muted font-light leading-relaxed" data-id="element-86">
                    {step}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
};